module.exports = __webpack_public_path__ + "img/20211102095519155jip.ad62f3c2.png";